module.exports = __webpack_public_path__ + "img/icon-cure2.9ad9e999.png";